module.exports = __webpack_public_path__ + "static/img/5.f66896a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/sp/5.png
// module id = 50BV
// module chunks = 0